import { Fragment } from 'react'
import _ from 'lodash'
import { ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import { HyperLink } from '../../../../Common/Form'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { getFailedListingIds } from '../../../helper/batch'

const UpdateFailedListingsSection = props => {
  const { listings, failedMap, proposalTypeName } = props
  const listingIds = getFailedListingIds(listings, failedMap)
  if (_.isEmpty(listingIds)) {
    return null
  }

  const idsStr = _.join(listingIds, COMMA)
  const lastIndex = _.size(listingIds) - 1
  return (
    <ProposalSection
      title='修改失敗'
      data-role='update-failed'
      warning
    >
      <ProposalBlock warning>
        {'賣場 '}
        {listingIds.map((id, index) => (
          <Fragment key={id}>
            <HyperLink href={`#${id}`}>
              {id}
            </HyperLink>
            {(lastIndex !== index) && COMMA}
          </Fragment>
        ))}
        {` ${proposalTypeName}提案失敗，您可`}
        <HyperLink
          target='_blank'
          href={`?listingIds=${idsStr}`}
        >
          重新提案
        </HyperLink>
      </ProposalBlock>
    </ProposalSection>
  )
}

export default UpdateFailedListingsSection
